<template>
<section>
  <article>
    <div class="loading" v-if="loading.state">
      <div class="loading__box">
        <div v-for="n in 12" class="loading__circle"></div>
      </div>
    </div>
    <ul v-else-if="searchResultsList.length != 0">
      <li class="item" v-for="result in searchResultsList" v-bind:id="result.id">
        <div class="item__header">
          <h3 class="item__header--title"><i class="item__header--icon onp-newspaper"></i> {{ result.newspaper_title }}</h3>
        </div>
        <div class="item__content">
          <div class="item__picture">
            <figure class="item__picture--figure">
              <img v-bind:src="result.thumbnail_url" v-on:error="brokenImgUrl($event)" alt="Image" class="item__picture--image">
            </figure>
          </div>
          <div class="item__infobox">

            <div class="item__infobox--row">
              <div class="item__infobox--label">{{ $lang.global.language }}:</div>
              <div class="item__infobox--content">
                  <span v-for="lang in result.language"><strong><check-lang-code v-bind:langCode="lang"></check-lang-code></strong></span>
              </div>
            </div>

            <div class="item__infobox--row" v-if="result.subject">
              <div class="item__infobox--label">{{ $lang.global.subject }}:</div>
              <div class="item__infobox--content">
                <span v-for="subject in result.subject">{{ subject }}</span>
              </div>
            </div>

            <div class="item__infobox--row" v-if="result.publisher">
              <div class="item__infobox--label">{{ $lang.global.publisher }}:</div>
              <div class="item__infobox--content">
                <span v-for="publisher in result.publisher"><strong>{{ publisher }}</strong></span>
              </div>
            </div>

            <div class="item__infobox--row" v-if="result.place_of_publishing">
              <div class="item__infobox--label">{{ $lang.global.place_of_publishing }}:</div>
              <div class="item__infobox--content">
                <span v-for="place_of_publishing in result.place_of_publishing">{{ place_of_publishing }}</span>
              </div>
            </div>

            <div class="item__infobox--row" v-if="result.data_provider">
              <div class="item__infobox--label">{{ $lang.global.data_provider }}:</div>
              <div class="item__infobox--content">
                <span v-for="data_provider in result.data_provider">{{ data_provider }}</span>
              </div>
            </div>

          </div>
        </div>
        <div class="item__footer">
          <div class="item__issue-period">
            {{ $lang.global.issue_period }}: <strong>{{ result.date_start | moment("YYYY") }} - {{ result.date_end | moment("YYYY") }}</strong>
          </div>
          <div class="item__count">
            {{ $lang.global.count }}: <strong v-bind:lang="$lang.language" v-thousand-number="result.count">{{ result.count }}</strong>
          </div>
          <div class="item__showFBC">
            <a class="item__showFBC--link" target="_blank" v-bind:href="fbcSearchQueryPrefix() + fbcSearchQueryByTitle(result.newspaper_title)">
              {{ $lang.global.show_FBC }} <i class="item__showFBC--icon onp-openwindow"></i>
            </a>
          </div>
        </div>
      </li>
    </ul>
    <div class="noresults" v-else>
      {{ $lang.search.results.no_results }}
    </div>
  </article>


  <div class="columns columns__bottom" v-if="searchResultsList.length != 0">
    <div class="column--ipp">
      <items-per-page></items-per-page>
    </div>
    <div class="column column--pagination">
      <pagination></pagination>
    </div>
  </div>

</section>
</template>

<script>
import { mapGetters} from 'vuex'
import configData from '../../config'
import getFbcQuery from '../../scripts/modules/search-results'

import Pagination from './../Global/Pagination'
import ItemsPerPage from './../Global/ItemsPerPage'
import checkLangCode from './../Global/CheckLangCode'

export default {
  name: 'search-results',
  components: {
    'pagination': Pagination,
    'items-per-page': ItemsPerPage,
    'check-lang-code': checkLangCode
  },
  methods: {
    brokenImgUrl (e) {
      e.target.src = configData().brokenImgUrl
      e.target.parentElement.classList.add('item__picture--error')
    },
    fbcSearchQueryPrefix: function() {
      return configData().FBC.path + configData().FBC.query.prefix
    },
    fbcSearchQueryByTitle: function(newspaperTitle) {
      return getFbcQuery(newspaperTitle)
    }
  },
  computed: {
    ...mapGetters({
      searchResultsNum: 'GET_SEARCH_RESULTS_NUM',
      searchResultsList: 'GET_SEARCH_RESULTS_DOCS',
      totalPagesNum: 'GET_TOTAL_PAGES_NUM',
      currentPage: 'GET_CURRENT_PAGE',
      rowsNum: 'GET_ROWS_NUM',
      loading: 'GET_LOADING_STATE',
      sortingParam: 'GET_SORTING',
      dateFrom: 'GET_DATE_FROM',
      dateTo: 'GET_DATE_TO',
      isDateSet: 'GET_IS_DATE_SET'
    })
  }
}
</script>



// WEBPACK FOOTER //
// SearchResults.vue?6bf034c0